/*
 * Created on Tue Oct 2 2019
 * Author: Val Liu
 * Copyright (c) 2019
 */

import { Vue } from "vue-property-decorator";
import { BehaviorSubject } from "rxjs";
import config from "@/config/default/container";

declare module "vue/types/vue" {
    export interface Vue {
        /// current applying theme
        $theme: typeof Vue;
    }
}

const sjTheme = new BehaviorSubject<typeof Vue>(config.container);

export const ThemePlugin = {
    install: function(Vue: any) {
        if (Vue._val_theme_installed) return;
        Vue._val_theme_installed = true;

        Vue.mixin({
            subscriptions: () => {
                return {
                    $theme: sjTheme,
                };
            },
        });
    },
};
